module.exports = __webpack_public_path__ + "static/media/mall_illustrated_map.6b7b313b.csv";